import { coreApi } from './api'

const fetchProfile = async (): Promise<Profile> => {
  const response = await coreApi.get('/me')
  const {
    id,
    attributes: { email, fullName, team, extensionNumber },
  } = response.data.data

  return {
    id,
    email,
    fullName,
    team,
    extensionNumber,
  }
}

export { fetchProfile }
